import clipboardCopy from 'clipboard-copy';
import { t } from 'i18next';
import { Resource, useResourceRoute } from 'json-api-hooks';
import React, { MouseEventHandler } from 'react';

import MenuItem from '../../components/MenuItem';
import useSnackbar from '../../hooks/useSnackbar';

const CopyMenuItem = ({ item }: { item: Resource }) => {
  const showSnackbar = useSnackbar();
  const route = useResourceRoute(item);
  const handleClick: MouseEventHandler = (e) => {
    e.preventDefault();
    clipboardCopy(route).then(() => showSnackbar(t('actions.copyFinished')));
  };

  return (
    <MenuItem href={route} icon="clipboard" onClick={handleClick}>
      Kopieer link
    </MenuItem>
  );
};

export default CopyMenuItem;
